export default "__VITE_ASSET__BhAq$OQX__"